import { EmptystateStacksColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import TileWrapper from "ds/components/Tile/Wrapper";

const DashboardWidgetsStacksRequiringAttentionEmpty = () => (
  <TileWrapper justify="center">
    <EmptyState
      title="No stacks to migrate"
      caption="None of your stacks run Terragrunt through the legacy Terraform vendor."
      icon={EmptystateStacksColored}
    />
  </TileWrapper>
);

export default DashboardWidgetsStacksRequiringAttentionEmpty;
